import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';
import {connect} from 'react-redux';

import ControlsComponent from '../components/controls/controls.jsx';
import {setStageCover, setWorkButState,setWorkDescription} from '../reducers/vm-status';

class Controls extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleBack',
            'handleGreenFlagClick',
            'handleStopAllClick',
            'handleGoCode',
            'handleWorkDetails'
        ]);
    }

    handleGreenFlagClick (e) {
        e.preventDefault();
        if (e.shiftKey) {
            this.props.vm.setTurboMode(!this.props.turbo);
        } else {
            if (!this.props.isStarted) {
                this.props.vm.start();
            }
            this.props.vm.greenFlag();
            this.props.setStageCover();
            this.props.setWorkButState(false);
        }
    }
    handleStopAllClick (e) {
        e.preventDefault();
        this.props.vm.stopAll();
        this.props.setWorkButState(true);
    }
    handleBack(){
        /* 返回作品介绍页 @米德 */
        // console.log(window.location.href);
        // console.log(window.location.href.indexOf('&courseware'));
        if (window.location.href.indexOf('&courseware')) {
            window.history.go(-1);
        } else if (window.history.go(-1) === undefined) {
            // location.href = `${location.protocol}//${location.host}/scratch/work.html?shareWorkUuid=${this.props.workUuid}`;
            let url = `${location.protocol}//${location.host}/#/work/${this.props.workUuid}/details?programType=scratch`;
            if (this.props.workIsShare) {
                url += '&isShare=1'
            }
            location.href = url;
        } else {
            window.history.go(-1);
        }
    }
    /* 探究源码*/
    handleGoCode(){
        window.location.href =`/scratch/viewer.html?workUuid=${this.props.workUuid}`;
    }
    /*作品简介*/
    handleWorkDetails(){
        this.props.setWorkDescription(true);
    }

    render () {
        const {
            vm, // eslint-disable-line no-unused-vars
            isStarted, // eslint-disable-line no-unused-vars
            projectRunning,
            workButState,
            workUuid,
            workType,
            turbo,
            setStageCover,
            setWorkButState,
            setWorkDescription,
            description,
            ...props
        } = this.props;
        return (
            <ControlsComponent
                {...props}
                active={projectRunning}
                turbo={turbo}
                onBack={this.handleBack}
                onGreenFlagClick={this.handleGreenFlagClick}
                onStopAllClick={this.handleStopAllClick}
                onGoCode={this.handleGoCode}
                onWorkDetails={this.handleWorkDetails}
                workButState={workButState}
                workInfo={props.workInfo}
                description={description}
            />
        );
    }
}

Controls.propTypes = {
    isMobile: PropTypes.bool,
    isStarted: PropTypes.bool.isRequired,
    projectRunning: PropTypes.bool.isRequired,
    turbo: PropTypes.bool.isRequired,
    vm: PropTypes.instanceOf(VM),
    workUuid: PropTypes.string,
    workType: PropTypes.number,
    setStageCover: PropTypes.func,
    setWorkButState: PropTypes.func,
    setWorkDescription:PropTypes.func,
    workButState: PropTypes.bool,
    workIsShare: PropTypes.number,
    workInfo: PropTypes.object,
};

const mapStateToProps = state => ({
    isStarted: state.scratchGui.vmStatus.running,
    projectRunning: state.scratchGui.vmStatus.running,
    turbo: state.scratchGui.vmStatus.turbo,
    workUuid: state.scratchGui.projectState.workUuid,
    workType: state.scratchGui.projectState.workType,
    workButState: state.scratchGui.vmStatus.workButState,
});
// no-op function to prevent dispatch prop being passed to component
const mapDispatchToProps = dispatch => ({
    setStageCover: () => dispatch(setStageCover()),
    setWorkButState: state => dispatch(setWorkButState(state)),
    setWorkDescription: state =>dispatch(setWorkDescription(state))
});

export default connect(mapStateToProps, mapDispatchToProps)(Controls);
